// @ts-nocheck

import React from 'react';
import { connect } from 'react-redux';
import map from 'lodash/map';
import PropTypes from 'prop-types';

import ListingWrapper from 'app/shared/modules/listing-cards/ListingWrapper';
import Center from 'app/shared/modules/Center';
import Row from 'app/shared/core/Row';
import Title from 'app/shared/modules/Title';
import * as styles from './waitlistSuccessPopup.styles';

class WaitlistSuccessPopup extends React.Component {
  static propTypes = {
    similarListings: PropTypes.array,
  };

  static defaultProps = {
    similarListings: [],
  };

  constructor(props) {
    super(props);
  }

  displaySimilarListings() {
    const { similarListings } = this.props;
    const shownSimilarListings = similarListings.slice(0, 2);

    if (shownSimilarListings.length > 0) {
      return (
        <div className={styles.SimilarListingsContainer}>
          <br />
          {map(shownSimilarListings, (similarListing) => {
            return (
              <ListingWrapper
                key={similarListing.aliasEncoded}
                listing={similarListing}
                triggerLocation="home_details"
                triggerObject="property_card"
              />
            );
          })}
        </div>
      );
    }

    return null;
  }

  render() {
    return (
      <div className={styles.WaitlistSuccessPopup}>
        <Center>
          <Title id="dialog-title" size="lg">
            You&apos;re on the waitlist!
          </Title>
        </Center>
        <Row>
          Success! Your name has been added to the waitlist. Once there&apos;s an available unit, we&apos;ll email you
          in no time.
        </Row>
        <Row>&apos;Til then, why don&apos;t you check out some similar listings?</Row>
        {this.displaySimilarListings()}
      </div>
    );
  }
}

export default connect()(WaitlistSuccessPopup);
